"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("../Utils");
/**
 * Helper functions for components hosting tree data grids.
 */
var TreeDataGridHostUtils = /** @class */ (function () {
    function TreeDataGridHostUtils() {
    }
    /**
     * A helper for tree data grid hosts to create new state when a row expansion state change occurred.
     * This method assumes that the host uses TreeDataGridHostState to maintain the state of expansion of its rows.
     * Will return the currentState for no-ops so that no re-rendering will occur (assuming pure-render).
     * @returns {S} Returns a state increment containing the now up-to-date expandedRowKeys.
     */
    TreeDataGridHostUtils.createStateIncrementOnExpansionChanges = function (currentState, changes) {
        var modifiedExpandedRowKeys = Utils_1.assign({}, currentState.expandedRowKeys);
        var expandedRowKeysWasModified = false;
        // tslint:disable-next-line
        for (var key in changes) {
            var isExpanded = changes[key];
            var changeOccurred = TreeDataGridHostUtils.addExpansionChange(modifiedExpandedRowKeys, key, isExpanded);
            expandedRowKeysWasModified = expandedRowKeysWasModified || changeOccurred;
        }
        if (!expandedRowKeysWasModified) {
            return currentState; // setState with the currentState should be no-op for pure render
        }
        return {
            expandedRowKeys: modifiedExpandedRowKeys
        };
    };
    TreeDataGridHostUtils.createStateIncrementOnExpansionChange = function (currentState, key, isExpanded) {
        var changes = {};
        changes[key] = isExpanded;
        return TreeDataGridHostUtils.createStateIncrementOnExpansionChanges(currentState, changes);
    };
    /**
     * @param {Dictionary<boolean>} expandedRowKeys - change will get added to this dictionary
     * @returns {boolean} Returns true if expandedRowKeys is gets modified, returns false otherwise.
     */
    TreeDataGridHostUtils.addExpansionChange = function (expandedRowKeys, rowKey, isExpanded) {
        var rowIsExpanded = TreeDataGridHostUtils.isRowExpanded(rowKey, expandedRowKeys);
        if ((isExpanded && rowIsExpanded) || (!isExpanded && !rowIsExpanded)) {
            return false;
        }
        if (isExpanded) {
            expandedRowKeys[rowKey] = true;
        }
        else {
            delete expandedRowKeys[rowKey];
        }
        return true;
    };
    TreeDataGridHostUtils.isRowExpanded = function (rowKey, expandedRowKeys) {
        var hasKey = Utils_1.has(expandedRowKeys, rowKey);
        return hasKey && expandedRowKeys[rowKey] === true;
    };
    return TreeDataGridHostUtils;
}());
exports.TreeDataGridHostUtils = TreeDataGridHostUtils;
//# sourceMappingURL=TreeDataGridHostUtils.js.map